exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-responsive {\n  height: 100%;\n  width: fit-content;\n  overflow: auto;\n}\n.table-responsive pre {\n  text-wrap: wrap;\n}\n.feature-popup-preformatted {\n}\n", ""]);

// exports
